export default "__VITE_ASSET__EaNwrQZL__"